// French
export const fr = {
    weeklyRewards: 'Récompenses hebdomadaires dans',
    days: 'jours',
    hours: 'heures',
    minutes: 'min',
    seconds: 'sec',
    authenticating: 'Authentification',
    verifyWallet: 'Veuillez patienter pendant que nous vérifions votre portefeuille',
    authRequired: 'Authentification requise',
    authFailed: "L'authentification a échoué. Veuillez réessayer.",
    points: 'Points',
    rank: 'Rang',
    of: 'sur',
    players: 'joueurs',
    weeklyTopPlayers: 'Meilleurs joueurs de la semaine',
    thisWeekLeaderboard: 'Classement de la semaine',
    rankingsReset: 'Les classements sont réinitialisés chaque dimanche à minuit UTC',
    yourPoints: 'Vos points',
    dailyRewardAvailable: 'Récompense quotidienne disponible !',
    nextClaimAvailable: 'Prochaine réclamation disponible dans :',
    claimDailyReward: 'Réclamer la récompense quotidienne',
    claiming: 'Réclamation...',
    multiplier: 'Multiplicateur',
    bonusPointsMultiplier: 'Multiplicateur de points bonus',
    outOf: 'sur',
    loading: 'Chargement...',
    errorLoading: 'Erreur de chargement',
    noEntries: "Pas d'entrées pour le moment",
    leaderboard: 'Classement',
    tasks: 'Tâches',
    rules: 'Règles',
    profile: 'Profil',
    comingSoon: 'Bientôt disponible...',
    completedTasks: 'Activités\nterminées',
    dailyRewardsClaimed: 'Récompenses quotidiennes réclamées',
    times: 'fois',
    recentActivity: 'Activité Récente',
    noRewardsClaimed: 'Aucune récompense réclamée pour le moment',
    dailyReward: 'Récompense quotidienne',
    howItWorks: 'Comment ça marche',
    welcomeMessage:
        'Bienvenue sur Coinomi Rewards ! Gagnez des points en accomplissant diverses tâches et grimpez dans le classement.',
    dailyRewardsTitle: 'Récompenses quotidiennes',
    dailyRewardsRules: [
        'Réclamez votre récompense quotidienne toutes les 24 heures',
        'Chaque réclamation vous donne 100 points',
        'Les points sont multipliés selon votre multiplicateur',
    ],
    multiplierBonusesTitle: 'Bonus multiplicateurs',
    multiplierBonusesRules: [
        'Commencez avec un multiplicateur 1x',
        'Connectez Telegram pour un bonus de +10%',
        'Vérifiez votre email pour un bonus de +10%',
        'Les bonus se cumulent pour des récompenses maximales',
    ],
    leaderboardTitle: 'Classement',
    leaderboardRules: [
        'Affrontez les autres joueurs',
        'Les classements sont mis à jour en temps réel',
        'Les meilleurs joueurs gagnent des récompenses spéciales',
    ],
    boostEarningsTitle: 'Augmentez vos gains',
    boostEarningsRules: [
        'Accomplissez des défis pour gagner des bonus',
        'Rejoignez notre communauté Telegram',
        'Restez actif pour maximiser vos récompenses',
    ],
    challenges: 'Défis',
    telegramChallenge: 'Défi Telegram',
    emailChallenge: 'Défi Email',
    connectTelegram: 'Se connecter avec Telegram',
    shareEmail: 'Partager email',
    telegramSuccess:
        '🎉 Félicitations ! Vous recevez maintenant un bonus permanent de 10% sur toutes les récompenses !',
    telegramPrompt:
        'Liez votre compte Telegram pour obtenir un bonus permanent de 10% sur toutes les récompenses !',
    emailSuccess:
        '🎉 Félicitations ! Vous recevez maintenant un bonus permanent de 10% sur toutes les récompenses !',
    emailPrompt:
        'Partagez votre email pour obtenir un bonus permanent de 10% sur toutes les récompenses !',
    connectEmail: 'Connecter email',
    cancel: 'Annuler',
    emailPrivacy:
        'Nous utiliserons votre email uniquement pour les mises à jour importantes et les notifications de récompenses.',
    connectYourEmail: 'Connectez votre email',
    emailBonus:
        '🎉 Obtenez un bonus permanent de 10% sur toutes les récompenses en connectant votre email !',
    enterValidEmail: 'Veuillez entrer une adresse email valide',
    emailAddress: 'Adresse email',
    errorSavingEmail: "Erreur lors de l'enregistrement de l'email. Veuillez réessayer.",
    claimButton: 'Réclamer',
    earnedReward: 'Récompense gagnée',
    rewardValue: '{{amount}} Points',
    claimSuccess: '{{amount}} points réclamés avec succès !',
    claimError: 'Échec de la réclamation. Veuillez réessayer.',
    privacyDisclaimer:
        'Coinomi ne collecte pas de données personnelles ; un système tiers gère de manière sécurisée les points et les liens sociaux.',
    streakBonus: 'Bonus de série',
    streakDays: '{{days}}/5 Jours',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Supplémentaire',
    streakDescription: 'Réclamez 5 jours de suite pour le bonus maximum',
    streakToday: "Aujourd'hui",
    streakMissed: 'Manqué',
    streakComplete: 'Complet',
    streakActive: 'Série active',
    streakLost: 'Série perdue',
    streakNext: 'Suivant',
    home: 'Accueil',
    currentStreak: 'Série actuelle',
    totalClaims: 'Total des réclamations',
    userStats: 'Vos statistiques',
    referrals: 'Parrainages',
    referralProgram: 'Programme de parrainage',
    howReferralWorks: 'Comment fonctionne le parrainage :',
    referralSteps: [
        'Partagez votre lien de parrainage avec vos amis',
        'Quand ils rejoignent via votre lien, ils deviennent vos filleuls',
        'Gagnez des points bonus pour chaque parrainage actif',
        'Suivez vos parrainages et gains ici',
    ],
    referralRewards: 'Les points de parrainage sont accordés :',
    referralBonuses: [
        "100 points lorsque vous parrainez quelqu'un",
        'et 10% de tous les points que le filleul obtient',
    ],
    yourReferralLink: 'Votre lien de parrainage',
    copyToClipboard: 'Copier dans le presse-papiers',
    linkCopied: 'Lien copié dans le presse-papiers !',
    totalReferrals: 'Total des parrainages',
    yourReferralCode: 'Votre code de parrainage',
    referralCodeCopied: 'Code de parrainage copié !',
    editReferralCode: 'Modifier le code de parrainage',
    editReferralCodeInstructions:
        'Choisissez un nouveau code de parrainage. Il doit contenir au moins 5 caractères et peut inclure des lettres et des chiffres.',
    newReferralCode: 'Nouveau code de parrainage',
    referralCodeRequirements: 'Minimum 5 caractères, lettres et chiffres uniquement',
    updating: 'Mise à jour...',
    update: 'Mettre à jour',
    referralCodeTaken: 'Ce code de parrainage est déjà pris',
    haveReferralCode: 'Vous avez un code de parrainage ?',
    enterReferralCodePrompt:
        "Si quelqu'un vous a parrainé, entrez son code ici pour connecter vos comptes.",
    enterReferralCode: 'Entrer le code de parrainage',
    enterReferralCodeInstructions: 'Entrez le code de parrainage partagé avec vous.',
    referralCode: 'Code de parrainage',
    referralCodeFormat: 'Lettres et chiffres uniquement',
    submitting: 'Envoi...',
    submit: 'Envoyer',
    enterCode: 'Entrer le code',
    pleaseAddtoken: "Veuillez ajouter un paramètre token à l'URL",
    authenticationError: "Une erreur s'est produite lors de l'authentification",
    noUserFound: 'Aucun utilisateur trouvé',
    userNotFoundMessage: "Impossible de trouver les données de l'utilisateur",
    backToHome: "Retour à l'accueil",
    retry: 'Réessayer',
    baseMultiplier: 'Multiplicateur de base',
    telegramBonus: 'Bonus Telegram',
    referralChallenge: 'Défi de parrainage',
    referralChallengePrompt:
        'Invitez des amis et gagnez des points bonus ! Obtenez 100 points pour chaque parrainage plus 10% de leurs gains.',
    startReferring: 'Commencer à parrainer',
    referralSuccess:
        '🎉 Félicitations ! Vous avez parrainé des utilisateurs avec succès et gagnez des points bonus !',
    unranked: 'Non classé',
    noPlayersYet: 'Soyez le premier à rejoindre !',
    shareVia: 'Partager via',
    shareOn: 'Partager sur {{network}}',
    shareInviteText:
        "🚀 Je gagne de la crypto gratuite avec @CoinomiWallet !\n\nTéléchargez Coinomi sur coinomi.com/downloads et entrez mon code de parrainage {{referralCode}} pour obtenir un bonus quand vous rejoignez #Coinomi Rewards dans l'app.",
    yourStatsThisWeek: 'Vos statistiques cette semaine',
    pointsMultiplier: 'Multiplicateur\nde points',
    yourRank: 'Votre\nrang',
    rewards: 'Récompenses',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    claimRewards: 'Réclamer les récompenses',
    privacyTitle: 'Coinomi ne collecte pas de données personnelles',
    privacyDescription: 'Un système tiers gère en toute sécurité les points et les liens sociaux.',
    walletAddress: 'Adresse du portefeuille',
    darkMode: 'Mode sombre',
    pointsAvailable: 'Points disponibles',
    player: 'Joueur',
    score: 'Score',
    youHaveReferred_zero: "Vous n'avez pas encore parrainé d'amis",
    youHaveReferred_one: 'Vous avez parrainé 1 ami',
    youHaveReferred_other: 'Vous avez parrainé {{count}} amis',
    referYourFriends: 'Parrainez vos amis',
    dailyRewardTooltip: 'Revenez chaque jour pour réclamer vos points et récompenses',
    weeklyRewardTooltip: 'Les récompenses sont distribuées de manière hebdomadaire',
    topPerformers: 'Meilleurs performeurs de la période sélectionnée',
    week: 'Semaine',
    year: 'Année',
    new_referral: 'Nouveau Parrainage',
    daily_reward: 'Récompense Quotidienne',
    referral_bonus: 'Bonus de Parrainage',
    copy: 'Copier',
    // Twitter Challenge
    twitterChallenge: 'Défi Twitter',
    connectTwitter: 'Connecter Twitter',
    twitterSuccess:
        '🎉 Félicitations ! Vous recevez maintenant un bonus permanent de 10% sur toutes les récompenses !',
    twitterPrompt:
        'Connectez votre compte Twitter pour obtenir un bonus permanent de 10% sur toutes les récompenses !',
    pleaseAddUserId: "Veuillez ajouter un paramètre userId à l'URL",
    emailChallengePrompt:
        'Partagez votre email pour obtenir un bonus permanent de 10% sur toutes les récompenses !',
    emailChallengeSuccess:
        '🎉 Connecté ! Vous recevez maintenant un bonus permanent de 10% sur toutes les récompenses !',
    followKoalaWalletChallenge: 'Suivez @coinomiWallet sur Twitter pour nous soutenir !',
    twitterAuthSuccessTitle: 'Twitter connecté avec succès !',
    twitterAuthSuccessMessage:
        "Vous avez connecté votre compte Twitter avec succès. Vous pouvez maintenant continuer à utiliser l'application.",
    continueToApp: "Continuer vers l'application",
    twitter_like: 'A aimé un tweet',
    twitter_retweet: 'A retweeté un tweet',
    disconnect: 'Déconnecter',
    followCoinomiWallet: 'Suivez @coinomiWallet sur Twitter pour nous soutenir !',
    connectedBonus:
        '🎉 Connecté ! Vous recevez désormais un bonus permanent de 10% sur toutes les récompenses !',
    // KPI Dashboard
    kpiDashboard: 'Tableau de bord KPI',
    totalUsers: 'Utilisateurs',
    twitterConnected: 'Twitter connecté',
    telegramConnected: 'Telegram connecté',
    emailConnected: 'Email connecté',
    recentRegistrations: 'Inscriptions 7j',
    activeUsers: 'Actifs 7j (profil)',
    activeUsersByScore: 'Actifs 7j (activité)',
    totalTasks: 'Tâches totales',
    totalRewards: 'Récompenses totales',
    totalPoints: 'Points distribués',
    topUser: 'Top utilisateur (7j)',
    engagementByType: 'Engagement par type de récompense (7j)',
};
